export const ExportToImageValues = {
  pngText: 'PNG',
  jpegText: 'JPEG',
  iconSize: 14,
};

export const eyeSvg = `<svg width="15px" height="12px" viewBox="0 0 15 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon/Eye</title>
    <defs>
        <path d="M7.4256,9.5715 C5.4666,9.5715 3.8776,7.9835 3.8776,6.0235 C3.8776,4.0645 5.4666,2.4755 7.4256,2.4755 C9.3846,2.4755 10.9736,4.0645 10.9736,6.0235 C10.9736,7.9835 9.3846,9.5715 7.4256,9.5715 L7.4256,9.5715 Z M11.1386,2.4715 L11.1376,2.4705 C10.1876,1.5625 8.8756,1.0005 7.4256,1.0005 C5.9756,1.0005 4.6626,1.5625 3.7126,2.4715 L-0.0004,6.0235 L3.7126,9.5755 C4.6626,10.4855 5.9756,11.0475 7.4256,11.0475 C8.8756,11.0475 10.1876,10.4855 11.1376,9.5765 L11.1386,9.5755 L14.8516,6.0235 L11.1386,2.4715 Z M9.1502,6.0236 C9.1502,6.9766 8.3782,7.7486 7.4252,7.7486 C6.4732,7.7486 5.7012,6.9766 5.7012,6.0236 C5.7012,5.0706 6.4732,4.2986 7.4252,4.2986 C8.3782,4.2986 9.1502,5.0706 9.1502,6.0236" id="path-1"></path>
    </defs>
    <g id="Icon/Eye" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"></use>
        </mask>
        <use id="Mask" fill="#808080" xlink:href="#path-1"></use>
        <g id="Tint/Gray/2" mask="url(#mask-2)" fill="#8a8a8a">
            <rect x="0" y="0" width="15" height="12"></rect>
        </g>
    </g>
</svg>
`;
